import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import '../styles/disclaimer.scss';
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import CitationComponent from './CitationComponent'
import Recommendation from '../models/Recommendation'
import Answer from '../models/Answer'
import NumPad from './NumPad'
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import * as constants from '../constants/constants'
import Persistence from '../Persistence/Persistence'
import NewLineHelper from '../utils/newLineHelper'
import StringHelper from '../utils/stringHelper'
import TextParser from '../models/TextParser'
import EmailHelper from '../utils/emailHelper'

class DisclaimerComponent extends Component {
  constructor() {
    super();
  }

  onDeclineClick(event) {

  }

  onAcceptClick(event) {
    Persistence.setHasAcceptedEULA(true);
    this.props.delegate.onEULAAccepted();
  }

  render() {
    return (
      <div className={"disclaimerRoot"}>
        <div className="disclaimerText">
        {constants.kEULA}
          </div>
        <div className="disclaimerButtonContainer">
          <div className="disclaimerButton disclaimerDeclineButton" onClick={this.onDeclineClick.bind(this)}>
            Decline
            </div>
          <div className="disclaimerButton disclaimerAcceptButton" onClick={this.onAcceptClick.bind(this)}>
          Accept
        </div>
        </div>
  </div>

    );
  }

}

export default DisclaimerComponent;



/** WEBPACK FOOTER **
 ** ./src/components/DisclaimerComponent.js
 **/